//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
export var getBlue = function (theme) {
    return theme.v1.color.blue.base;
};
export var getLightBlue = function (theme) {
    return theme.v1.color.blue.light;
};
export var getDarkBlue = function (theme) {
    return theme.v1.color.blue.dark;
};
export var getRed = function (theme) {
    return theme.v1.color.red.base;
};
export var getLightRed = function (theme) {
    return theme.v1.color.red.light;
};
export var getDarkRed = function (theme) {
    return theme.v1.color.red.dark;
};
export var getGreen = function (theme) {
    return theme.v1.color.green.base;
};
export var getLightGreen = function (theme) {
    return theme.v1.color.green.light;
};
export var getDarkGreen = function (theme) {
    return theme.v1.color.green.dark;
};
export var getYellow = function (theme) {
    return theme.v1.color.yellow.base;
};
export var getLightYellow = function (theme) {
    return theme.v1.color.yellow.light;
};
export var getDarkYellow = function (theme) {
    return theme.v1.color.yellow.dark;
};
export var getGrey = function (theme) {
    return theme.v1.color.grey.base;
};
export var getLightGrey = function (theme) {
    return theme.v1.color.grey.light;
};
export var getDarkGrey = function (theme) {
    return theme.v1.color.grey.dark;
};
export var getATBlue = function (theme) {
    return theme.v1.color.atBlue;
};
export var getATRed = function (theme) {
    return theme.v1.color.atRed;
};
export var getWhite = function (theme) {
    return theme.v1.color.white;
};
export var getActionColor = function (theme) {
    return theme.v1.color.action.base;
};
export var getActionActiveColor = function (theme) {
    return theme.v1.color.action.active;
};
export var getActionHoverColor = function (theme) {
    return theme.v1.color.action.hover;
};
export var getVisitedColor = function (theme) {
    return theme.v1.color.visited;
};
export var getFocusColor = function (theme) {
    return theme.v1.color.focus;
};
export var getGraphicColor = function (theme) {
    return theme.v1.color.graphic;
};
export var getErrorColor = function (theme) {
    return theme.v1.color.error;
};
export var getSuccessColor = function (theme) {
    return theme.v1.color.success;
};
export var getAccentColor = function (theme) {
    return theme.v1.color.accent;
};
export var getPlaceholderColor = function (theme) {
    return theme.v1.color.placeholder;
};
export var getTitleColor = function (theme) {
    return theme.v1.color.title;
};
export var getCopyColor = function (theme) {
    return theme.v1.color.copy;
};
export var getDarkAlertColor = function (theme) {
    return theme.v1.color.alert.dark;
};
export var getLightAlertColor = function (theme) {
    return theme.v1.color.alert.light;
};
export var getDarkDefaultColor = function (theme) {
    return theme.v1.color.default.dark;
};
export var getLightDefaultColor = function (theme) {
    return theme.v1.color.default.light;
};
export var getDarkInfoColor = function (theme) {
    return theme.v1.color.info.dark;
};
export var getLightInfoColor = function (theme) {
    return theme.v1.color.info.light;
};
export var getDarkWarningColor = function (theme) {
    return theme.v1.color.warning.dark;
};
export var getLightWarningColor = function (theme) {
    return theme.v1.color.warning.light;
};
export var getColorDecorBgSurface = function (theme) {
    return theme.v1.color.decor.bgSurface.default;
};
export var getColorDecorBgSurfaceSoft = function (theme) {
    return theme.v1.color.decor.bgSurface.soft;
};
export var getColorDecorBgSurfaceSecondary = function (theme) {
    return theme.v1.color.decor.bgSurface.secondary.default;
};
export var getColorDecorBgSurfaceSecondarySoft = function (theme) {
    return theme.v1.color.decor.bgSurface.secondary.soft;
};
/*
 * ----------------
 * Legacy selectors
 * ----------------
 *
 * Use the current theme when migration is complete
 * During migration use the theme we're migrating from
 */
export var getLegacyRed = function (theme) {
    return theme.sparkplug.color.base.red.base;
};
export var getLegacyLightRed = function (theme) {
    return theme.sparkplug.color.base.red.light;
};
export var getLegacyDarkRed = function (theme) {
    return theme.sparkplug.color.base.red.dark;
};
export var getLegacyBlue = function (theme) {
    return theme.sparkplug.color.base.blue.base;
};
export var getLegacyLightBlue = function (theme) {
    return theme.sparkplug.color.base.blue.light;
};
export var getLegacyDarkBlue = function (theme) {
    return theme.sparkplug.color.base.blue.dark;
};
export var getLegacyAqua = function (theme) {
    return theme.sparkplug.color.base.aqua.base;
};
export var getLegacyLightAqua = function (theme) {
    return theme.sparkplug.color.base.aqua.light;
};
export var getLegacyDarkAqua = function (theme) {
    return theme.sparkplug.color.base.aqua.dark;
};
export var getLegacyGrey = function (theme) {
    return theme.sparkplug.color.base.grey.base;
};
export var getLegacyLightGrey = function (theme) {
    return theme.sparkplug.color.base.grey.light;
};
export var getLegacyDarkGrey = function (theme) {
    return theme.sparkplug.color.base.grey.dark;
};
export var getLegacyYellow = function (theme) {
    return theme.sparkplug.color.base.yellow.base;
};
export var getLegacyLightYellow = function (theme) {
    return theme.sparkplug.color.base.yellow.light;
};
export var getLegacyDarkYellow = function (theme) {
    return theme.sparkplug.color.base.yellow.dark;
};
export var getLegacyGreen = function (theme) {
    return theme.sparkplug.color.base.green.base;
};
export var getLegacyLightGreen = function (theme) {
    return theme.sparkplug.color.base.green.light;
};
export var getLegacyDarkGreen = function (theme) {
    return theme.sparkplug.color.base.green.dark;
};
export var getLegacyInstagramColor = function (theme) {
    return theme.sparkplug.color.base.social.instagram;
};
export var getLegacyFacebookColor = function (theme) {
    return theme.sparkplug.color.base.social.facebook;
};
export var getLegacyYouTubeColor = function (theme) {
    return theme.sparkplug.color.base.social.youtube;
};
export var getLegacyPiPositiveColor = function (theme) {
    return theme.sparkplug.color.base.tags.piPositive;
};
export var getLegacyPiBestColor = function (theme) {
    return theme.sparkplug.color.base.tags.piBest;
};
export var getLegacyWhite = function (theme) {
    return theme.sparkplug.color.base.white;
};
export var getLegacyCopyLightColor = function (theme) {
    return theme.sparkplug.color.base.copyLight;
};
export var getLegacyPlaceholderColor = function (theme) {
    return theme.sparkplug.color.base.placeholder;
};
export var getLegacyLinkColor = function (theme) {
    return theme.sparkplug.color.base.link;
};
